import React from 'react';
import { Button, Form, Radio, Search } from 'semantic-ui-react';
import _ from 'lodash'
import ResponsiveDateInput from '../componentsHelpers/ResponsiveDateInput';
import storeArray from '../utilities/storeList';

import styled from "styled-components";
import { ErrorMessage } from "formik";

const RedText = styled.p`
  color: red;
  animation: fadein 1s;

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const initialState = { isLoading: false, results: [] };

const storeList = storeArray.map(store => {
    const parsedStore = JSON.parse(store);
    return {
        title: parsedStore.store,
        description: parsedStore.address + ', ' + parsedStore.postcode
    }
})

class WorkFormB extends React.Component<any, any> {
    state = initialState;

    next = (e: any) => {
        e.preventDefault();
        this.props.gaEvent('event', 'InitialCriteria', 'Next', 'Boots', this.props.isValid);
        this.props.nextStep(this.props);
    }

    renderDateField(dateTypeName: string, dateTypeVal: string) {
        /* conditionally render the date field */
        if (this.props.values[dateTypeName] === dateTypeVal) {
            return (
                <Form.Group grouped>
                    <ResponsiveDateInput
                        isMobile={(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))}
                        name="stp1_endDate"
                        label="End Date"
                        id="stp1_endDate"
                        setFieldValue={this.props.setFieldValue}
                        values={this.props.values}
                    />
                    <ErrorMessage
                        name='stp1_endDate'
                        render={msg => <RedText className="error"> {msg} </RedText>}
                    />
                </Form.Group>
            );
        }
    }

    handleResultSelect = (e: object, vals: any) => {
        const { title } = vals.result;
        this.props.setFieldValue('stp1_storeDetails', title);
    };

    handleSearchChange = (e: object, vals: any) => {
        const { value } = vals;
        this.setState({ isLoading: true });
        this.props.setFieldValue('stp1_storeDetails', value);

        setTimeout(() => {
            const val = this.props.values.stp1_storeDetails;
            if (val < 1) {
                this.props.setFieldValue('stp1_storeDetails', '');
                return this.setState(initialState);
            };

            const re = new RegExp(val, 'i');
            const isMatch = ( result : any ) => { return re.test(result.title) || re.test(result.description) };

             this.setState({
                isLoading: false,
                results: _.filter(storeList, isMatch).slice(0,4)
            })
        }, 500);
    }

    renderAdditionalFields() {
        const { isLoading, results } = this.state

        if (this.props.values.stp1_stillWorkThere !== '') {
            return (
                <React.Fragment>
                    <Form.Group grouped>
                        <label>What Co-operative Group Limited food store do/did you work at?</label>
                        <Search
                            input={{ fluid: true }}
                            fluid
                            loading={isLoading}
                            name="stp1_storeDetails"
                            placeholder="Chorlton - Wilbraham Road"
                            onResultSelect={this.handleResultSelect}
                            onSearchChange={this.handleSearchChange}
                            results={results}
                            value={this.props.values.stp1_storeDetails}
                        />
                        <ErrorMessage
                            name={'stp1_storeDetails'}
                            render={msg => <RedText className="error"> {msg} </RedText>}
                        />
                    </Form.Group>
                    <Form.Group grouped>
                        <label>Are/were you paid an hourly wage?</label>
                        <Form.Field>
                            <Radio
                                label='Yes'
                                name='stp1_hourlyWage'
                                value='yes'
                                checked={this.props.values.stp1_hourlyWage === 'yes'}
                                onChange={() => {
                                    this.props.setFieldValue("stp1_hourlyWage", "yes");
                                }
                                }
                            // data-testid='wfb-radio-yes'
                            />
                        </Form.Field>
                        <Form.Field>
                            <Radio
                                label='No'
                                name='stp1_hourlyWage'
                                value='no'
                                checked={this.props.values.stp1_hourlyWage === 'no'}
                                onChange={() => this.props.setFieldValue("stp1_hourlyWage", "no")}
                            // data-testid='wfb-radio-no'
                            />
                        </Form.Field>
                        <ErrorMessage
                            name={'stp1_hourlyWage'}
                            render={msg => <RedText className="error"> {msg} </RedText>}
                        />
                    </Form.Group>
                </React.Fragment>
            );
        }
    }

    render() {
        return (
            <React.Fragment>
                <Form.Group grouped>
                    <label>Do you still work at a food store for Co-operative Group Limited?</label>
                    <Form.Field>
                        <Radio
                            label='Yes'
                            name='stp1_stillWorkThere'
                            value='yes'
                            checked={this.props.values.stp1_stillWorkThere === 'yes'}
                            onChange={() => {
                                this.props.setFieldValue("stp1_endDate", "");
                                this.props.setFieldValue("stp1_stillWorkThere", "yes");
                            }
                            }
                        // data-testid='wfb-radio-yes'
                        />
                    </Form.Field>
                    <Form.Field>
                        <Radio
                            label='No'
                            name='stp1_stillWorkThere'
                            value='no'
                            checked={this.props.values.stp1_stillWorkThere === 'no'}
                            onChange={() => this.props.setFieldValue("stp1_stillWorkThere", "no")}
                        // data-testid='wfb-radio-no'
                        />
                    </Form.Field>
                    {/* <Form.Field>
                        <Radio
                            label='Yes, but I am working a notice period'
                            name='stp1_stillWorkThere'
                            value='notice-period'
                            checked={this.props.values.stp1_stillWorkThere === 'notice-period'}
                            onChange={() => {
                                this.props.setFieldValue("stp1_endDate", "");
                                this.props.setFieldValue("stp1_stillWorkThere", "notice-period")
                            }
                            }
                            // data-testid='wfb-radio-notice'
                        />
                    </Form.Field> */}
                    <ErrorMessage
                        name={'stp1_stillWorkThere'}
                        render={msg => <RedText className="error"> {msg} </RedText>}
                    />
                </Form.Group>
                {this.renderDateField('stp1_stillWorkThere', 'no')}
                {this.renderAdditionalFields()}
                <Button.Group widths="2">
                    <Button id='nextButton' labelPosition='right' floated='right' color={this.props.isValid ? 'green' : 'grey'} icon='right chevron' content='Next' onClick={this.next} data-testid='wfb-button' />
                </Button.Group>

            </React.Fragment>
        )
    }
}

export default WorkFormB;